import React from "react";
import DepositoLotePanel from "./DepositoLotePanel";

export default function DepositoLoteRow({
  lote,
  isOpen,
  detail,
  editState,
  onRowClick,
  onNotaFiscalChange,
  onPedidoTransferenciaChange,
  onDocsKeyDown,
  onSaveDocs,
  onCancelDocs,
  formatDate,
  formatInt,
  formatNumber,
  joinDocumentos,
}) {
  const code = String(lote?.codigo_lote || "");

  return (
    <>
      <tr
        className={`dep-lote-row ${isOpen ? "is-open" : ""} ${editState ? "is-editing" : ""}`.trim()}
        onClick={onRowClick}
        title="1 clique: abre/fecha barras | 2 cliques: editar/salvar documentos"
      >
        <td>{formatDate(lote?.data_referencia || lote?.created_at)}</td>
        <td>{lote?.codigo_lote || ""}</td>
        <td>{lote?.origem || ""}</td>
        <td>{lote?.perfil_trilho || ""}</td>
        <td>
          {editState ? (
            <textarea
              className="dep-docs-editor"
              value={editState.notaFiscalText}
              onChange={(event) => onNotaFiscalChange(event.target.value)}
              onClick={(event) => event.stopPropagation()}
              onKeyDown={onDocsKeyDown}
              placeholder="Ex.: 330301 | 554420"
            />
          ) : (
            <span className="dep-docs-preview" title={joinDocumentos(lote?.nota_fiscal)}>
              {joinDocumentos(lote?.nota_fiscal)}
            </span>
          )}
        </td>
        <td>
          {editState ? (
            <div className="dep-docs-edit-cell" onClick={(event) => event.stopPropagation()}>
              <textarea
                className="dep-docs-editor"
                value={editState.pedidoTransferenciaText}
                onChange={(event) => onPedidoTransferenciaChange(event.target.value)}
                onKeyDown={onDocsKeyDown}
                placeholder="Ex.: PT-001 | PT-002"
              />
              <div className="dep-docs-side-actions">
                <button
                  type="button"
                  className="dep-docs-side-btn dep-docs-side-btn-save"
                  onClick={onSaveDocs}
                  disabled={Boolean(editState?.saving)}
                >
                  {editState?.saving ? "Salv..." : "Salvar"}
                </button>
                <button
                  type="button"
                  className="dep-docs-side-btn dep-docs-side-btn-cancel"
                  onClick={onCancelDocs}
                  disabled={Boolean(editState?.saving)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          ) : (
            <span className="dep-docs-preview" title={joinDocumentos(lote?.pedido_transferencia)}>
              {joinDocumentos(lote?.pedido_transferencia)}
            </span>
          )}
        </td>
        <td>{String(lote?.recebimento_geracao || "").toUpperCase() === "SIM" ? "Sim" : "Não"}</td>
        <td>{lote?.carreta || ""}</td>
        <td>{lote?.cavalo || ""}</td>
        <td>{formatInt(lote?.total_barras)}</td>
        <td>{formatNumber(lote?.total_toneladas, 3)}</td>
        <td>{formatNumber(lote?.total_metragem)}</td>
      </tr>

      {editState?.error ? (
        <tr className="dep-docs-error-row">
          <td colSpan={12}>
            <p className="dep-docs-error">{editState.error}</p>
          </td>
        </tr>
      ) : null}

      {editState ? (
        <tr className="dep-docs-hint-row">
          <td colSpan={12}>
            <p className="dep-docs-hint">Ctrl+Enter para salvar, Esc para cancelar.</p>
          </td>
        </tr>
      ) : null}

      {isOpen ? (
        <tr className="dep-lote-expand-row">
          <td colSpan={12}>
            <DepositoLotePanel
              lote={lote}
              detail={detail}
              formatDate={formatDate}
              formatInt={formatInt}
              formatNumber={formatNumber}
              inline
            />
          </td>
        </tr>
      ) : null}
    </>
  );
}
